const api_routes = [
    // {
    //     href: "/",
    //     src: "/assets/img/svg/home.svg",
    //     acronym: "Home",
    //     name: "home-group",
    //     rl: {
    //         title: "Home",
    //         hrefs: [],
    //     },
    // },
    {
        href: "/facility",
        src: "/assets/img/svg/facilities_ds.svg",
        acronym: "Facility",
        name: "facility-group",
        rl: {
            title: "",
            hrefs: [],
        },
    },

    {
        href: "#",
        src: "/assets/img/svg/buildings_ds.svg",
        acronym: "Buildings",
        name: "building-group",
        rl: {
            title: "Buildings",
            hrefs: [
                {
                    name: "Buildings",
                    route: "/buildings",
                },
                {
                    name: "Levels",
                    route: "/building-levels",
                },
                {
                    name: "Areas",
                    route: "/building-areas",
                },
                {
                    name: "Rooms",
                    route: "/building-rooms",
                },
                {
                    name: "Cost center",
                    route: "/building-cost-center",
                },
                {
                    name: "Department",
                    route: "/building-departments",
                },
                {
                    name: "Personnel",
                    route: "/building-personel",
                },
                {
                    name: "Room type",
                    route: "/building-room-types",
                },
            ],
        },
    },

    {
        href: "#",
        src: "/assets/img/svg/associates_ds.svg",
        acronym: "Associates",
        name: "associates-group",
        rl: {
            title: "Associates",
            hrefs: [
                {
                    name: "Associates",
                    route: "/associates",
                },
                {
                    name: "Positions",
                    route: "/associate-positions",
                },
                {
                    name: "Contact types",
                    route: "/associate-contract-types",
                },
            ],
        },
    },

    {
        href: "#",
        src: "/assets/img/svg/assignments_ds.svg",
        acronym: "Assignments",
        name: "assignments-group",
        rl: {
            title: "Assignments",
            hrefs: [
                {
                    name: "Daily assignments",
                    route: "/assignment-daily-assignments",
                },
                {
                    name: "Statuses",
                    route: "/assignment-statuses",
                },
                {
                    name: "Shifts",
                    route: "/assignment-shifts",
                },
                {
                    name: "Tasks",
                    route: "/assignment-tasks",
                },
                {
                    name: "Projects",
                    route: "/assignment-projects",
                },
                // {
                //     name: "Project work lists",
                //     route: "/assignment-project-work-lists",
                // },
                // {
                //     name: "Project work tasks",
                //     route: "/assignment-project-work-tasks",
                // },
                {
                    name: "Service request",
                    route: "/assignment-service-request",
                },
            ],
        },
    },

    {
        href: "#",
        src: "/assets/img/svg/budgetingM.svg",
        acronym: "Budgeting",
        name: "budgeting-group",
        rl: {
            title: "Budgeting",
            hrefs: [
                {
                    name:   "Staffing scenarios",
                    route:  "/budgeting-staffing-scenario",
                },
                // {
                //     name:   "Staffing scenarios V2",
                //     route:  "/budgeting-staffing-scenario-v2",
                // },
                {
                    name:   "Forecaster",
                    route:  "/budgeting-forecaster"
                },
                // {
                //     name:   "Wizzards",
                //     route:  "/budgeting-wizzard",
                // },
            ]
        }
    },

    {
        href: "#",
        src: "/assets/img/svg/censusM.svg",
        acronym: "Census",
        name: "census-group",
        rl: {
            title: "Census",
            hrefs: [
                {
                    name: 'Vacant beds',
                    route: '/census-vacant-beds'
                },
                // {
                //     name: 'Worksheets',
                //     route: '/census-worksheets'
                // },
                // {
                //     name: 'Time tracking',
                //     route: '/census-time-tracking'
                // },
                {
                    name: 'Log productivity',
                    route: '/census-log-productivity'
                },
                // {
                //     name: 'Call in',
                //     route: '/census-call-in'
                // }
            ]
        }
    },

    {
        href: "#",
        src: "/assets/img/svg/days-offM.svg",
        acronym: "Days off",
        name: "days-off-group",
        rl: {
            title: "Days Off",
            hrefs: [
                {
                    name: 'Schedule Templates',
                    route: '/days-off-templates'
                },
                {
                    name: 'Live Schedules',
                    route: '/days-off-schedules'
                },
                {
                    name: 'Days Off Setup'
                    // route: '/days-off-schedules'
                },
                // {
                //     name: 'Rotation Days',
                //     route: '/days-off-rotation-setups'
                // },
                {
                    name: 'Rotation Templates',
                    route: '/days-off-rotation-templates'
                },
            ]
        }
    },

    {
        href: "#",
        src: "/assets/img/svg/QCM.svg",
        acronym: "QC",
        name: "qc-group",
        rl: {
            title: "QC",
            hrefs: [
                // {
                //     name: 'Inspection Type',
                //     route: '/qc-inspection-type'
                // },
                // {
                //     name:  'Room QC inventory',
                //     route:  '/qc-room-inventory'
                // },
                {
                    name: 'Inspection templates',
                    route: '/qc-inspection-template'
                },
                {
                    name: 'Inspection',
                    route: '/qc-inspection'
                },
                {
                    name: 'Surveys',
                    route: '/qc-surveys'
                },
            ]
        },
    },

    {
        href: "#",
        src: "/assets/img/svg/utilitiesM.svg",
        acronym: "Utilities",
        name: "utilities-group",
        rl: {
            title: "Utilities",
            hrefs: [
                {
                    name: 'Walking number update',
                    route: '/utilities-walking-number-update'
                },
                {
                    name:  'Project codes mass delete',
                    route:  '/utilities-project-codes-mass-delete'
                },
                {
                    name: 'Project codes mass add',
                    route: '/utilities-project-codes-mass-add'
                },
                {
                    name: "Recycle Bin",
                    route: "/recycle-bin"
                }
            ]
        },
    },
    
    {
        href: "#",
        src: "/assets/img/svg/optionsM.svg",
        acronym: "Options",
        name: "options-group",
        rl: {
            title: "Options",
            hrefs: [
                {
                    name: "Default project codes",
                    route: "/options-default-project-codes",
                },
                {
                    name: "Bed numbers",
                    route: "/options-bed-numbers",
                },
                {
                    name: "Bed codes",
                    route: "/options-bed-codes",
                },
                {
                    name: "Step codes",
                    route: "/options-step-codes",
                },
                {
                    name: 'Master step codes',
                    route: '/options-master-step-codes'
                },
                {
                    name: 'Groups',
                    route: '/options-groups'
                },
                {
                    name: 'V. Beds adjustment',
                    route: '/options-vacant-bed-adjustment'
                },
                {
                    name: 'Inventory sets',
                    route: '/options-project-inventory-sets'
                },
                // {
                //     name: 'Default project code',
                //     route: '/options-default-project-code'
                // },
                {
                    name: 'Inventory items',
                    route: '/options-project-inventory-items'
                },
                {
                    name: 'Floor types',
                    route: '/options-floor-types'
                },
                {
                    name: 'Specialities',
                    route: '/options-specialities'
                },
                {
                    name: 'Time off',
                    route: '/options-time-off'
                }
            ],
        },
    },

    {
        href: "/reports",
        src: "/assets/img/svg/ReportsIcon.svg",
        acronym: "Reports",
        name: "reports-group",
        rl: {
            title: "Reports",
            hrefs: [
                {
                    name: "Reports",
                    route: "/reports",
                },
            ],
        },
    },
    
    /**
        {
            href: "",
            src: "/assets/img/svg/days-offM.svg",
            acronym: "Days off",
            name: "days-off-group",
            rl: {
                title: "",
                hrefs: [],
            },
        },
        {
            href: "",
            src: "/assets/img/svg/QCM.svg",
            acronym: "QC",
            name: "qc-group",
            rl: {
                title: "",
                hrefs: [],
            },
        },
        {
            href: "",
            src: "/assets/img/svg/utilitiesM.svg",
            acronym: "Utilities",
            name: "utilities-group",
            rl: {
                title: "",
                hrefs: [],
            },
        },
         */
];

export default api_routes;